import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  copy: { id: "investigation.list.copy", defaultMessage: "Copy" },
  copied: { id: "investigation.list.copied", defaultMessage: "Copied" },
  failed: { id: "investigation.list.copyFailed", defaultMessage: "Copy failed" },
});

/** Labels of a `CopyableId` (identifier with a copy button). */
export function useCopyLabels() {
  const intl = useIntl();
  return {
    label: intl.formatMessage(messages.copy),
    copiedLabel: intl.formatMessage(messages.copied),
    failedLabel: intl.formatMessage(messages.failed),
  };
}
